var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "thead-default"
  }, [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("ShippingId")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Pending Days")]), _vm._v(" "), (_vm.isCourierCompanyId) ? _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Agent Id")]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.svcInScanPendingList), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "text-center"
    }, [_c('td', [_vm._v(_vm._s(item.shippingid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.pendingdays))]), _vm._v(" "), (_vm.isCourierCompanyId) ? _c('td', [_vm._v(_vm._s(item.courierid))]) : _vm._e()])
  }), _vm._v(" "), (_vm.svcInScanPendingList.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "35",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e()], 2)]), _c('br')])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d8ad548","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/common/svcInScanPending.vue
// module id = 1035
// module chunks = 1